module.exports = __webpack_public_path__ + "static/IEEENLPCertificate-4416975322b50b62cd4b930283956098.jpg";